<div #container class="apb-container">
    <button [routerLink]="['/']">
        <ion-icon name="home-outline"></ion-icon
        ><span>{{ "Home" | translate }}</span>
    </button>
    <button (click)="onProfileClick()">
        <ion-icon name="person-outline"></ion-icon
        ><span>{{ (isUserLoggedIn ? "Log out" : "Log in") | translate }}</span>
    </button>
    <button mdTextButton (click)="cartButtonService.goToCheckout()">
        <div class="he-cart">
            <ion-icon
                *ngIf="!cartButtonService.hasItemsInCart()"
                class="he-button"
                name="cart-outline"
            ></ion-icon>
            <img
                *ngIf="cartButtonService.hasItemsInCart()"
                [src]="'assets/icons/appbar/cart.svg'"
                style="width: 24px; margin-top: 8px"
            />
            <span
                class="he-cart-count"
                *ngIf="cartButtonService.hasItemsInCart()"
                >{{ cartButtonService.getCartItemCount() }}</span
            >
        </div>
        <span>{{ "Cart" | translate }}</span>
    </button>
    <button (click)="openSidebar()">
        <ion-icon name="menu-outline"></ion-icon
        ><span>{{ "Menu" | translate }}</span>
    </button>
    <button
        [disabled]="!isUserLoggedIn"
        [ngClass]="{ disabled: !isUserLoggedIn }"
        [routerLink]="['/customer/bookings']"
    >
        <img
            [src]="'assets/icons/appbar/trips.svg'"
            style="width: 24px"
        /><span>{{ "Trips" | translate }}</span>
    </button>
</div>

<ng-template #signOutModal let-modal>
    <div class="apb-modal-header">
        <h4 class="apb-modal-title">
            {{ "Log out" | translate }}
        </h4>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
        ></button>
    </div>
    <div class="apb-modal-body">
        <p>{{ "Are you sure you want to log out?" | translate }}</p>
        {{ "You will be redirected to the home page." | translate }}
    </div>
    <div class="apb-modal-footer">
        <button mdMainButton="light" type="button" (click)="onSignOut()">
            {{ "Yes" | translate }}
        </button>
        <button
            type="button"
            mdMainButton="dark"
            (click)="modal.close('Save click')"
        >
            {{ "Cancel" | translate }}
        </button>
    </div>
</ng-template>
